export default "__VITE_ASSET__B05Jg5K7__"